module.exports = __webpack_public_path__ + "static/V-Class Extra long-9564b2b604fec736597d1fa85be8e06e.jpg";